<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" epub:type="pagebreak" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2022 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2022</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">31 30 29 28 27 26 25 24 23 22 1     2 3 4 5</p>
<p class="crtf"><span class="sm">ISBN</span>-13: 978-0-226-82098-9 (cloth)</p>
<p class="crt"><span class="sm">ISBN</span>-13: 978-0-226-82100-9 (paper)</p>
<p class="crt"><span class="sm">ISBN</span>-13: 978-0-226-82099-6 (e-book)</p>
<p class="crt"><span class="sm">DOI</span>: <a class="url" href="https://doi.org/10.7208/chicago/9780226820996.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226820996.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Crosthwaite, Paul, 1980– author. | Knight, Peter, 1968– author. | Marsh, Nicky, author. | Paul, Helen J., 1975– author. | Taylor, James, 1976–author.</p>
<p class="cip">Title: Invested : how three centuries of stock market advice reshaped our money, markets, and minds / Paul Crosthwaite, Peter Knight, Nicky Marsh, Helen Paul, and James Taylor.</p>
<p class="cip">Other titles: How three centuries of stock market advice reshaped our money, markets, and minds</p>
<p class="cip">Description: Chicago ; London : The University of Chicago Press, 2022. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: <span class="sm">LCCN</span> 2022012505 | <span class="sm">ISBN</span> 9780226820989 (cloth) | <span class="sm">ISBN</span> 9780226821009 (paperback) | <span class="sm">ISBN</span> 9780226820996 (ebook)</p>
<p class="cip">Subjects: <span class="sm">LCSH</span>: Investments—History. | Investment advisors—Great Britain—History. | Investment advisors—United States—History. | Finance literature—Great Britain—History. | Finance literature—United States—History. | Capitalism—History.</p>
<p class="cip">Classification: <span class="sm">LCC</span> <span class="sm">HG</span>4516 .<span class="sm">C</span>76 2022 | <span class="sm">DDC</span> 332/.0415—dc23/eng/20220502</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2022012505" target="_blank">https://lccn.loc.gov/2022012505</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of <span class="sm">ANSI/NISO</span> <span class="sm">Z</span>39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-crosthwaite-0004.vue?7c5ba82c